import { API_BASE_URL, API_TOKEN } from './config';

export const createTeam = async (formData) => {
  const fd = new FormData();
  fd.append('action', "createTeam");
  fd.append('API_TOKEN', API_TOKEN);

  fd.append("teamname", formData["teamname"]);
  fd.append("teamorg", formData["teamorg"]);

  try {
    const response = await fetch(API_BASE_URL, {
      method: 'POST',
      credentials: "include",
      //headers: { "Content-Type": "application/json" },
      body: fd,
    });
    const data = await response.json();
    alert(data.message);
    //console.log(data);
    return data;
  } catch (error) {
    console.error('Error creating team:', error);
    throw error;
  }
};

export const fetchTeams = async () => {
  const fd = new FormData();
  fd.append('action', "fetchTeams");
  fd.append('API_TOKEN', API_TOKEN);

  try {
    const response = await fetch(API_BASE_URL, {
      method: 'POST',
      //headers: { "Content-Type": "application/json" },
      body: fd,
    });
    const data = await response.json();
    //alert(data.message);
    //console.log(data.teams);
    return data.teams;
  } catch (error) {
    console.error('Error fetching teams:', error);
    throw error;
  }
};

export const getTeamDetails = async (teamname) => {
  const fd = new FormData();
  fd.append('action', "getTeamDetails");
  fd.append('API_TOKEN', API_TOKEN);
  fd.append('teamname', teamname);

  try {
    const response = await fetch(API_BASE_URL, {
      method: 'POST',
      credentials: "include",
      //headers: { "Content-Type": "application/json" },
      body: fd,
    });
    const data = await response.json();
    return data.teamdata;
  } catch (error) {
    console.error('Error fetching team details:', error);
    throw error;
  }
};

export const editTeam = async (formData) => {
  const fd = new FormData();
  fd.append('action', "editTeam");
  fd.append('API_TOKEN', API_TOKEN);

  fd.append("teamname", formData["teamname"]);
  fd.append("teamorg", formData["teamorg"]);
  //console.log(formData);

  try {
    const response = await fetch(API_BASE_URL, {
      method: 'POST',
      credentials: "include",
      //headers: { "Content-Type": "application/json" },
      body: fd,
    });
    const data = await response.json();
    alert(data.message);
    //console.log(data);
    return data;
  } catch (error) {
    console.error('Error creating team:', error);
    throw error;
  }
};

export const requestToJoinTeam = async (teamname) => {
  const fd = new FormData();
  fd.append('action', "requestToJoinTeam");
  fd.append('API_TOKEN', API_TOKEN);

  fd.append("teamname", teamname);

  try {
    const response = await fetch(API_BASE_URL, {
      method: 'POST',
      credentials: "include",
      //headers: { "Content-Type": "application/json" },
      body: fd,
    });
    const data = await response.json();
    alert(data.message);
    //console.log(data);
    return data;
  } catch (error) {
    console.error('Error creating team:', error);
    throw error;
  }
};

export const leaveTeam = async (formData) => {
  const fd = new FormData();
  fd.append('action', "leaveTeam");
  fd.append('API_TOKEN', API_TOKEN);

  try {
    const response = await fetch(API_BASE_URL, {
      method: 'POST',
      credentials: "include",
      //headers: { "Content-Type": "application/json" },
      body: fd,
    });
    const data = await response.json();
    alert(data.message);
    //console.log(data);
    return data;
  } catch (error) {
    console.error('Error creating team:', error);
    throw error;
  }
};

export const requestCoach = async (formData) => {
  const fd = new FormData();
  fd.append('action', "requestCoach");
  fd.append('API_TOKEN', API_TOKEN);

  fd.append("coachname", formData["coachName"]);
  //console.log(formData);

  try {
    const response = await fetch(API_BASE_URL, {
      method: 'POST',
      credentials: "include",
      //headers: { "Content-Type": "application/json" },
      body: fd,
    });
    const data = await response.json();
    alert(data.message);
    //console.log(data);
    return data;
  } catch (error) {
    console.error('Error creating team:', error);
    throw error;
  }
};

// Dummy data template still in use
export const removeMember = async (teamname, memberName) => {
  // Dummy API call for removing a team member.
  console.log(`Removing member ${memberName} from team ${teamname}`);
  // Simulate removal success response after a delay.
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({ message: "Member removed successfully" });
    }, 500);
  });
};

// Dummy data template no longer in use
export const getTeamDetails1 = async (teamname) => {
  // Dummy data for now
  const dummyData = {
    name: teamname,
    org: "University of Benin",
    liuitm: true, // liuitm -> logged in user is team member
    members: [
      { name: "John Doe", role: "Coach" },
      { name: "Jane Smith", role: "Member" },
      { name: "Alice Johnson", role: "Member" },
      { name: "Johnny Test", role: "Member" }
    ]
  };
  return dummyData;
};
export const editTeam1 = async (formData) => {
  // Dummy API call for editing a team.
  console.log("Editing team with data:", formData);
  // Simulate success response after a small delay.
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({ message: "Team updated successfully" });
    }, 500);
  });
};